import { addDiscountBadgesToCrossSellingItems, addDiscountIndicators, bindQuantityButtonClickHandler, initializeQuantityButtons, swapAttributeImagesForEnglish } from '../default-modules/default-utils';

let hooksBound = false;

export function productPageFunctionality() {
  if (!document.body.classList.contains('page-Product')) return;

  moveDescriptionText();
  moveAttributeSpecs();
  removePriceWrapperIfEmpty();
  addQtyBtns();
  addListProductDecorations();
  bindUpdateHooks();
  addDiscountIndicators(document.querySelector('.product-wrapper'));
  swapAttributeImagesForEnglish(document.querySelector('.product-wrapper'));
  addPlaceholderImage();
}

export function crossSellingFunctionality() {
  const crossSellingRoot = document.getElementById('crossSelling');
  if (!crossSellingRoot) return;

  if (document.getElementById('wl-cross-selling')) return;

  waitForCrossItems(crossSellingRoot, () => setupCrossSelling(crossSellingRoot));
}

function waitForCrossItems(element, callback) {
  if (element.querySelectorAll('.cross-item').length) {
    callback();
    return;
  }

  const intervalId = setInterval(() => {
    if (element.querySelectorAll('.cross-item').length) {
      clearInterval(intervalId);
      callback();
    }
  }, 200);

  setTimeout(() => clearInterval(intervalId), 5000);
}

function setupCrossSelling(crossSellingRoot) {
  const isSlickActive = crossSellingRoot.classList.contains('slick-initialized');
  // Vi vet inte längre om slick kommer vara aktiverat eller inte så vi måste ta hänsyn till båda.
  const itemRoot = isSlickActive ? extractItemsFromSlick(crossSellingRoot) : extractItemsWithoutSlick(crossSellingRoot);

  rebuildCrossSellingItems(itemRoot);
  moveCrossSellingPriceInRoot(itemRoot);
  addDiscountBadgesToCrossSellingItems(itemRoot);
  addDiscountIndicators(itemRoot);
  swapAttributeImagesForEnglish(itemRoot);
  resolveHqyLazyImages(itemRoot);
  initializeQuantityButtons('.wl-cross-selling-list .quantity', '.numeric');
  bindQuantityButtonClickHandler();
}

// Ersätt placeholder-bilder med den riktiga bilden från data-src
function resolveHqyLazyImages(root) {
  root.querySelectorAll('img.hqy-lazy[data-src]').forEach((img) => {
    img.src = img.getAttribute('data-src');
    img.removeAttribute('data-src');
    img.classList.remove('hqy-lazy');

    const wrapper = img.closest('.hqy-wrapper');
    if (wrapper) wrapper.classList.add('hqy-loaded');
  });
}

function extractItemsWithoutSlick(crossSellingRoot) {
  const wrapper = document.createElement('div');
  wrapper.className = 'wl-cross-selling-list';
  wrapper.id = 'wl-cross-selling';

  crossSellingRoot.querySelectorAll('.cross-item').forEach((item) => {
    wrapper.appendChild(item);
  });

  crossSellingRoot.insertAdjacentElement('afterend', wrapper);
  crossSellingRoot.remove();

  return wrapper;
}

// Klonar cross-item-elementen och tar sedan bort #crossSelling helt
// så att Slick inte har något att återinitiera på resize.
function extractItemsFromSlick(crossSellingRoot) {
  const wrapper = document.createElement('div');
  wrapper.className = 'wl-cross-selling-list';
  wrapper.id = 'wl-cross-selling';

  crossSellingRoot.querySelectorAll('.cross-item:not(.slick-cloned)').forEach((item) => {
    const clone = item.cloneNode(true);

    clone.style.width = '';
    clone.removeAttribute('data-slick-index');
    clone.removeAttribute('aria-hidden');
    clone.removeAttribute('tabindex');
    clone.classList.remove('slick-slide', 'slick-current', 'slick-active');

    if (clone.hasAttribute('id')) clone.removeAttribute('id');
    clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));

    wrapper.appendChild(clone);
  });

  crossSellingRoot.insertAdjacentElement('afterend', wrapper);
  crossSellingRoot.remove();

  return wrapper;
}

function bindUpdateHooks() {
  if (hooksBound) return;
  hooksBound = true;

  const prm = window.Sys?.WebForms?.PageRequestManager?.getInstance?.();
  if (prm) {
    prm.add_pageLoaded((_sender, args) => {
      const updated = args.get_panelsUpdated?.() || [];
      const updatedIds = updated.map((p) => p?.id).filter(Boolean);

      // Kör bara när "UpdatePanelInfoWrapper" kör. Tror det är den som kör på produktsidan efter lagd i varukorg
      if (updatedIds.includes('UpdatePanelInfoWrapper')) {
        productPageFunctionality();
        crossSellingFunctionality();
      }
    });
  }
}

const LIST_PRODUCT_ROOT_SELECTORS = ['.prodlist']; // TODO kommer säkert behövas fler här. för kassa etc

function addQtyBtns() {
  initializeQuantityButtons('.page-Product .quantity', '.numeric');

  bindQuantityButtonClickHandler();
}

function addListProductDecorations() {
  LIST_PRODUCT_ROOT_SELECTORS.forEach((selector) => {
    document.querySelectorAll(selector).forEach((root) => {
      addDiscountIndicators(root);
    });
  });
}

function rebuildCrossSellingItems(root) {
  root.querySelectorAll('.cross-item').forEach((item) => {
    const descriptionWrapper = item.querySelector('.description-wrapper');
    if (!descriptionWrapper) return;

    const inner = descriptionWrapper.closest('.inner') ?? item.querySelector('.inner');
    if (!inner) return;

    if (inner.querySelector('.wl-cross-selling-description')) return;

    const clone = descriptionWrapper.cloneNode(true);
    clone.classList.add('wl-cross-selling-description', 'wl-script-added');

    inner.appendChild(clone);
  });
}

function moveCrossSellingPriceInRoot(root) {
  root.querySelectorAll('.cross-item').forEach((item) => {
    const movedDescription = item.querySelector('.wl-cross-selling-description');
    if (!movedDescription) return;

    const priceWrapper = item.querySelector('.buy-inner .price-wrapper');
    if (!priceWrapper?.querySelector('.price')) return;

    const priceClone = priceWrapper.cloneNode(true);
    movedDescription.appendChild(priceClone);
  });
}

function moveDescriptionText() {
  const descriptionContainer = document.getElementById('Description');
  const productInformationContainer = document.getElementById('ProductInfo');

  if (!descriptionContainer || !productInformationContainer) return;

  const productNameElement = productInformationContainer.querySelector('.product-name');
  if (!productNameElement) return;

  const textContainerEl = extractAndMoveDescription(descriptionContainer, productNameElement);
  if (!textContainerEl) return;

  initReadMoreToggle(textContainerEl, productInformationContainer);
}

function extractAndMoveDescription(descriptionContainer, productNameElement) {
  const descriptionText = descriptionContainer.querySelector('.text');
  if (!descriptionText) return null;

  const clone = descriptionText.cloneNode(true);

  clone.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((h) => h.remove());
  clone.querySelectorAll('.fw-truncateButton').forEach((el) => el.remove());

  clone.querySelectorAll('p').forEach((p) => {
    if (p.textContent.trim() === '') {
      p.remove();
    }
  });

  clone.querySelectorAll('[style*="width"]').forEach((el) => {
    el.style.width = '';
  });

  const textContainerEl = document.createElement('div');
  textContainerEl.className = 'wl-product-description-text';
  textContainerEl.innerHTML = clone.innerHTML;

  productNameElement.insertAdjacentElement('afterend', textContainerEl);

  return textContainerEl;
}

function initReadMoreToggle(textContainerEl, productInformationContainer) {
  const COLLAPSED_MAX_HEIGHT = 210; // px – tune to taste

  // Hämta "Läs mer" / "Stäng"-texter från Pyramids egna truncate-knapp innan vi klonar och rensar.
  // Structur: <a class="fw-truncateButton">
  //   <span class="fw-truncateButtonLabel fw-truncateButtonLabelHide">Läs mer ...</span>
  //   <span class="fw-truncateButtonLabel">Stäng</span>
  // </a>
  const truncateBtn = document.body.querySelector('.fw-truncateButton');
  const labelLess = truncateBtn?.querySelector('.fw-truncateButtonLabelHide')?.textContent.trim() || 'More...';
  const labelMore = truncateBtn?.querySelector('.fw-truncateButtonLabel:not(.fw-truncateButtonLabelHide)')?.textContent.trim() || 'Close';

  requestAnimationFrame(() => {
    if (textContainerEl.scrollHeight <= COLLAPSED_MAX_HEIGHT) return;

    textContainerEl.classList.add('is-clamped');
    textContainerEl.style.maxHeight = `${COLLAPSED_MAX_HEIGHT}px`;

    const fade = document.createElement('div');
    fade.className = 'wl-description-fade';
    textContainerEl.appendChild(fade);

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wl-read-more-btn wl-script-added';
    btn.textContent = labelMore;
    textContainerEl.insertAdjacentElement('afterend', btn);

    let expanded = false;

    btn.addEventListener('click', () => {
      expanded = !expanded;

      if (expanded) {
        textContainerEl.style.maxHeight = `${textContainerEl.scrollHeight}px`;
        textContainerEl.classList.remove('is-clamped');
        btn.textContent = labelLess;
      } else {
        textContainerEl.style.maxHeight = `${COLLAPSED_MAX_HEIGHT}px`;
        textContainerEl.classList.add('is-clamped');
        btn.textContent = labelMore;

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        productInformationContainer.scrollIntoView({ behavior: prefersReducedMotion ? 'instant' : 'smooth', block: 'start' });
      }
    });

    textContainerEl.addEventListener('transitionend', () => {
      if (expanded) {
        textContainerEl.style.maxHeight = 'none';
      }
    });
  });
}

function moveAttributeSpecs() {
  const productInformationContainer = document.getElementById('ProductInfo');
  if (!productInformationContainer) return;

  if (productInformationContainer.querySelector('.wl-product-info-accordion')) return;

  const sections = [
    { containerId: 'Specifications', titleId: 'SpecificationsTitle', contentId: 'SpecificationsInfo' },
    { containerId: 'ProductLinks', titleId: 'LinksTitle', contentId: 'LinksList' }
  ];

  const items = sections.flatMap(({ containerId, titleId, contentId }) => {
    const container = document.getElementById(containerId);
    const titleEl = document.getElementById(titleId);
    const contentEl = document.getElementById(contentId);

    if (!container || !titleEl || !contentEl) return [];
    if (!contentEl.textContent.trim()) return [];

    return [{ title: titleEl.textContent.trim(), contentEl, className: `wl-${containerId.toLowerCase()}` }];
  });

  if (!items.length) return;

  const accordion = document.createElement('div');
  accordion.className = 'wl-product-info-accordion';

  items.forEach(({ title, contentEl, className }) => {
    const item = document.createElement('div');
    item.className = `wl-product-info-accordion-item ${className}`;

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'wl-product-info-accordion-trigger';
    trigger.setAttribute('aria-expanded', 'false');
    trigger.textContent = title;

    const body = document.createElement('div');
    body.className = 'wl-product-info-accordion-body';
    body.appendChild(contentEl);

    trigger.addEventListener('click', () => {
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!isExpanded));
      item.classList.toggle('is-open', !isExpanded);
    });

    item.appendChild(trigger);
    item.appendChild(body);
    accordion.appendChild(item);
  });

  productInformationContainer.insertAdjacentElement('beforeend', accordion);
}

function addPlaceholderImage() {
  const imagesContainer = document.getElementById('Images');
  if (!imagesContainer) return;

  // Check if placeholder already added
  if (imagesContainer.querySelector('.wl-product-placeholder')) return;

  const imageLink = imagesContainer.querySelector('#image_link');
  const mainImage = imageLink?.querySelector('img');

  // If no image element exists, or src is empty/missing
  const hasImage = mainImage && mainImage.getAttribute('src');

  if (!hasImage) {
    const placeholder = document.createElement('img');
    placeholder.src = '/images/user/product-placeholder.png';
    placeholder.alt = 'Produktbild saknas';
    placeholder.className = 'wl-product-placeholder';

    if (imageLink) {
      imageLink.appendChild(placeholder);
    } else {
      const wrapper = imagesContainer.querySelector('.selected-image-wrapper');
      if (wrapper) {
        wrapper.appendChild(placeholder);
      }
    }
  } else {
    // Handle broken images — check if already failed or listen for future error
    const applyPlaceholder = () => {
      if (imagesContainer.querySelector('.wl-product-placeholder')) return;

      mainImage.src = '/images/user/product-placeholder.png';
      mainImage.alt = 'Produktbild saknas';
      mainImage.classList.add('wl-product-placeholder');
    };

    if (mainImage.complete && mainImage.naturalWidth === 0) {
      applyPlaceholder();
    } else {
      mainImage.addEventListener('error', function handleError() {
        mainImage.removeEventListener('error', handleError);
        applyPlaceholder();
      });
    }
  }
}

function removePriceWrapperIfEmpty() {
  const priceWrapper = document.getElementById('PriceWrapper');
  if (!priceWrapper) return;

  if (priceWrapper.textContent.trim() === '') {
    priceWrapper.remove();
  }
}
